"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnologyStructFromCode = exports.ReservedFromCode = exports.ClimateClassFromCode = exports.PEDALS = exports.PedalFromCode = exports.VoltageFromCode = exports.RefrigerationGasFromCode = exports.CompressorFromCode = exports.TankTechnologyFromCode = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Device.Class.Gbfc.Technology';
exports.TankTechnologyFromCode = effect_1.Schema.transformLiterals(['HB', 'HV IB Sparkling 300W heater'], ['HE', 'HV IB Sparkling 800W heater'], ['HV', 'HV IB Sparkling 500W heater'], ['IB', 'Ice Bath WL7'], ['NA', 'GBFC Non-Pressurized 2.5L UVC-LED'], ['ND', 'GBFC Non-Pressurized 8.0L UVC-LED'], ['NE', 'GBFC Non-Pressurized 3.1L UVC-LED'], ['PA', 'GBFC Pressurized 1.5L UVC-LED'], ['PC', 'GBFC Pressurized 4L UVC-LED Cold Tank']).annotations({
    identifier: `${NAMESPACE}.TankTechnologyFromCode`,
});
exports.CompressorFromCode = effect_1.Schema.transformLiterals(['D', 'Danfu China'], ['K', 'Sikelan China'], ['L', 'LG China'], ['P', 'Donper China']).annotations({
    identifier: `${NAMESPACE}.CompressorFromCode`,
});
exports.RefrigerationGasFromCode = effect_1.Schema.transformLiterals([1, 'R134a'], [6, 'R600']).annotations({
    identifier: `${NAMESPACE}.RefrigerationGasFromCode`,
});
exports.VoltageFromCode = effect_1.Schema.transformLiterals([1, '120V@60Hz'], [2, '220-240V@50Hz'], [4, '220-240V@60Hz'], [6, '220-240V@50-60Hz']).annotations({
    identifier: `${NAMESPACE}.VoltageFromCode`,
});
exports.PedalFromCode = effect_1.Schema.transformLiterals([0, 'No Pedal'], [1, 'Contactless']).annotations({
    identifier: `${NAMESPACE}.PedalFromCode`,
});
exports.PEDALS = {
    NoPedal: 'No Pedal',
    Contactless: 'Contactless',
};
exports.ClimateClassFromCode = effect_1.Schema.transformLiterals(['N', 'Normal'], ['T', 'High']).annotations({
    identifier: `${NAMESPACE}.ClimateClassFromCode`,
});
exports.ReservedFromCode = effect_1.Schema.Literal('X').annotations({
    identifier: `${NAMESPACE}.ReservedFromCode`,
});
exports.TechnologyStructFromCode = effect_1.Schema.TemplateLiteralParser(exports.TankTechnologyFromCode, exports.CompressorFromCode, exports.RefrigerationGasFromCode, exports.VoltageFromCode, exports.PedalFromCode, exports.ClimateClassFromCode, exports.ReservedFromCode)
    .pipe(effect_1.Schema.transform(effect_1.Schema.Struct({
    tankTechnology: effect_1.Schema.typeSchema(exports.TankTechnologyFromCode),
    compressor: effect_1.Schema.typeSchema(exports.CompressorFromCode),
    refrigerationGas: effect_1.Schema.typeSchema(exports.RefrigerationGasFromCode),
    voltage: effect_1.Schema.typeSchema(exports.VoltageFromCode),
    pedal: effect_1.Schema.typeSchema(exports.PedalFromCode),
    climateClass: effect_1.Schema.typeSchema(exports.ClimateClassFromCode),
    _reserved: effect_1.Schema.typeSchema(exports.ReservedFromCode),
}), {
    strict: true,
    decode: ([tankTechnology, compressor, refrigerationGas, voltage, pedal, climateClass, _reserved,]) => ({
        tankTechnology,
        compressor,
        refrigerationGas,
        voltage,
        pedal,
        climateClass,
        _reserved,
    }),
    encode: ({ tankTechnology, compressor, refrigerationGas, voltage, pedal, climateClass, _reserved, }) => [
        tankTechnology,
        compressor,
        refrigerationGas,
        voltage,
        pedal,
        climateClass,
        _reserved,
    ],
}))
    .annotations({
    identifier: `${NAMESPACE}.TechnologyStructFromCode`,
    pretty: () => ({ tankTechnology, compressor, refrigerationGas, voltage, pedal, climateClass }) => [tankTechnology, compressor, refrigerationGas, voltage, pedal, climateClass].join(' '),
});
//# sourceMappingURL=technology.js.map